import Button from "../../../components/common/Button/Button";
import images from "../../../images";
import { cn } from "../../../Utils/helper";
import { ProgressBarXPProfile } from "./ProgressBarXPProfile";

export const ProfileCard = ({
  coinAmount,
  dollarValue = "$3.00",
  onWithdraw,
  subTitle = "Rally Coins",
  className = "",
  xpAmount,
  xpCurrent = 0,
  maxXP = 10,
  status = "newbie",
  imageCard,
  nextTire,
  currentXp,
  total,
  level,
  subPowerUpImage,
  subPowerUpImageSecond,
  onClickCard,
}) => {
  return (
    <section
      onClick={onClickCard}
      className={cn(
        "flex flex-row justify-between mx-auto bg-[#ECEEFF] rounded-md min-h-[150px] max-md:my-0 max-md:w-full max-sm:w-full p-5 w-full max-w-[480px] relative",
        className
      )}
    >
      <div className="flex flex-col justify-between flex-1 min-w-0 pr-3 max-w-[65%]">
        <div className="flex flex-row gap-2 items-center">
          <img
            className="w-[20px] h-[20px] object-cover"
            src={imageCard}
            alt=""
          />
          <h6 className="text-[#253FF6] font-[Figtree] text-[16px] font-bold not-italic leading-none">
            {subTitle}
          </h6>
        </div>
        {coinAmount !== undefined && coinAmount !== null && (
          <>
            <h1 className="text-[#253FF6] font-[Figtree] text-[48px] font-bold not-italic leading-none tracking-[-0.96px] break-words word-break">
              {parseInt(coinAmount)}
            </h1>

            <span className="text-[#253FF6] font-[Figtree] text-[10px] font-bold not-italic leading-none">
              100 Rally Coins = SGD 1.00
            </span>
          </>
        )}

        {subPowerUpImage && subPowerUpImageSecond && (
          <>
            <div className="flex flex-row gap-2 items-center">
              <img src={subPowerUpImage} alt="" />
              <img src={subPowerUpImageSecond} alt="" />
            </div>
            <div></div>
          </>
        )}

        {currentXp && (
          <>
            <h1 className="text-[#253FF6] font-[Figtree] text-[48px] max-w-[300px] font-bold not-italic leading-none tracking-[-0.96px]">
              {parseInt(currentXp)}
            </h1>
            <ProgressBarXPProfile currentXp={currentXp} total={total} />
            <div className="text-[10px] text-[#253FF6]">
              Earn <strong>{parseInt(total - currentXp)} XP</strong> more to{" "}
              <strong>Level {level + 1}</strong>
            </div>
          </>
        )}
      </div>
      {coinAmount !== undefined && coinAmount !== null && (
        <div className="flex flex-col-reverse justify-between items-end flex-shrink-0">
          <Button
            className="max-w-[145px] w-[145px] items-center rounded-md max-h-[40px] text-xl font-medium text-white bg-[#253FF6]"
            onClick={() => {
              onWithdraw && onWithdraw();
            }}
            text="Withdraw"
          />
        </div>
      )}

      {currentXp && (
        <div className="absolute bottom-[-5px] right-3">
          <img src={images.XPProfileImage} alt="" />
        </div>
      )}
    </section>
  );
};

export default ProfileCard;
